import React, { useEffect, useRef, useState } from "react";
import { Package, Upload, X, Save, ArrowLeft } from "lucide-react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import ProductVariantForm from "../ProductVariantForm";
import ShippingRatesManager from "../ShippingRatesManager";
import ProductImages from "../ProductImages";

const BackendUrl = process.env.REACT_APP_Backend_Url;
const admin = JSON.parse(localStorage.getItem("AdminEcomme"));
export default function AddProduct() {
  const [isLoading, setIsLoading] = useState(false);
  const [variants, setVariants] = useState([]);
  const [mainImages, setMainImages] = useState({
    image1: null,
    image2: null,
    image3: null,
  });
  const [currentImages, setCurrentImages] = useState({
    image1: "",
    image2: "",
    image3: "",
  });
  const [imagesToDelete, setImagesToDelete] = useState([]); //1
  const [preview, setPreview] = useState({
    current: "",
    images: [],
  });
  // États avec valeurs initiales
  const [zones, setZones] = useState([]);
  // État pour le formulaire d'ajout de transporteur
  const [nouveauTransporteur, setNouveauTransporteur] = useState({
    name: "",
    contact: "",
  });
  const [transporteurs, setTransporteurs] = useState([]);
  const [selectedOriginZone, setSelectedOriginZone] = useState("Europe");
  // État pour le formulaire d'ajout de zone
  const [nouvelleZone, setNouvelleZone] = useState({
    name: "",
    code: "",
    id: 1,
  });
  const [shippingOptions, setShippingOptions] = useState([]);
  const [packageDimensions, setPackageDimensions] = useState({
    weight: 0,
    length: 0,
    width: 0,
    height: 0,
  });
  const [productData, setProductData] = useState({
    desc: "",
    name: "",
    price: "",
    quantity: 0,
    fournisseur: "",
    price_Promo: 0,
    prixF: 0,
    Categorie: "",
    type_de_Produits: "",
    marque: "inconu",
    deliveryPrice: 0,
  });

  const [categories, setCategories] = useState([]);
  const [ClefCategorie, setClefCategorie] = useState("");
  const [formErrors, setFormErrors] = useState({});

  if (admin) {
    console.log("admin");
    axios.defaults.headers.common["Authorization"] = `Bearer ${admin.token}`;
  }
  const productImagesRef = useRef();
  const handleAlert = (message) => {
    toast.success(`${message} !`);
  };

  const handleAlertwar = (message) => {
    toast.warn(`${message} !`);
  };

  // Fonction pour afficher les toasts
  const showToast = ({ type, message }) => {
    switch (type) {
      case "success":
        toast.success(message);
        break;
      case "error":
        toast.error(message);
        break;
      case "warning":
        toast.warning(message);
        break;
      default:
        toast.info(message);
    }
  };

  useEffect(() => {
    // Charger les données initiales
    Promise.all([axios.get(`${BackendUrl}/api/categoriesRoutes`)])
      .then(([categoriesRes]) => {
        setCategories(categoriesRes.data.data);
      })
      .catch((error) => {
        toast.error("Erreur lors du chargement des données");
        console.error(error);
      });
  }, []);

  const handleImageChange = (e, type) => {
    const file = e.target.files?.[0];
    if (file) {
      setMainImages((prev) => ({ ...prev, [type]: file }));
      setPreview((prev) => ({
        ...prev,
        current: URL.createObjectURL(file),
        images: [...prev.images, URL.createObjectURL(file)],
      }));
    }
  };

  // Fonction de validation
  function validateTransporteurs(transporteurs) {
    if (!Array.isArray(transporteurs) || transporteurs.length === 0) {
      handleAlertwar("Le tableau est vide ou invalide.");
      return false;
    }

    const requiredFields = [
      "name",
      "baseFee",
      // "weightFee",
      "transporteurContact",
      "transporteurId",
      "transporteurName",
    ];

    for (let i = 0; i < transporteurs.length; i++) {
      const transporteur = transporteurs[i];

      // Vérification des champs requis
      for (const field of requiredFields) {
        if (!(field in transporteur)) {
          handleAlertwar(`Champ manquant: ${field} à l'index ${i + 1}`);
          return false;
        }
      }

      // Vérification des types de données
      if (
        typeof transporteur.name !== "string" ||
        transporteur.name.trim() === ""
      ) {
        handleAlertwar(`Nom invalide à l'index ${i + 1}.`);
        return false;
      }
      if (
        typeof transporteur.transporteurContact !== "string" ||
        !/^[0-9]{8}$/.test(transporteur.transporteurContact)
      ) {
        handleAlertwar(`Contact du transporteur invalide à l'index ${i + 1}}.`);
        return false;
      }
      if (
        typeof transporteur.transporteurId !== "number" ||
        transporteur.transporteurId <= 0
      ) {
        handleAlertwar(`ID du transporteur invalide à l'index ${i + 1}}.`);
        return false;
      }
      if (
        typeof transporteur.baseFee !== "number" ||
        transporteur.baseFee < 0
      ) {
        handleAlertwar(`Frais de base invalide à l'index ${i + 1}.`);
        return false;
      }
      if (
        typeof transporteur.weightFee !== "number" ||
        transporteur.weightFee < 0
      ) {
        handleAlertwar(`Frais par Killo invalide à l'index ${i + 1}.`);
        return false;
      }
      if (
        typeof transporteur.transporteurName !== "string" ||
        transporteur.transporteurName.trim() === ""
      ) {
        handleAlertwar(`Nom du transporteur invalide à l'index ${i + 1}}.`);
        return false;
      }
    }

    handleAlert("Validation réussie.");
    return true;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(shippingOptions);
    // return;
    const errorMessages = {
      image1: "Vous devez mettre l'image1",
      image2: "Vous devez mettre l'image2",
      image3: "Vous devez mettre l'image3",
      colors: "Vous devez mettre au moins une couleur du produit",
      tails: "Vous devez mettre au moins une taille du produit",
      descriptionLength: "La description doit comporter au moins 20 caractères",
      priceInvalid: "Le prix est incorrect",
      quantityInvalid: "La quantité n'est pas valide",
      categorieInvalid: "La catégorie n'est pas valide",

      // Messages pour les dimensions du produit
      weightInvalid: "Le poids du produit doit être supérieur à 0",
      lengthInvalid: "La longueur du produit doit être supérieure à 0",
      widthInvalid: "La largeur du produit doit être supérieure à 0",
      heightInvalid: "La hauteur du produit doit être supérieure à 0",
      zoneInvalid: "vous deviez mettre au moins une option de livrason",
      origineInvalid: "vous deviez mettre votre zone d'origine ",
    };

    const regexNumber = /^\d+(\.\d+)?$/;

    if (!mainImages.image1) {
      handleAlertwar(errorMessages.image1);
      return;
    }

    // Vérifiez les autres champs obligatoires de la même manière

    if (productData.desc.length <= 20) {
      console.log(productData.desc);
      handleAlertwar(errorMessages.descriptionLength);
      return;
    }

    if (!regexNumber.test(productData.price) || Number(productData.price) < 0) {
      handleAlertwar(errorMessages.priceInvalid);
      return;
    }

    if (
      !regexNumber.test(String(productData.quantity)) ||
      Number(productData.quantity) <= 0
    ) {
      handleAlertwar(errorMessages.quantityInvalid);
      return;
    }

    // Valider les images
    const imagesValid = productImagesRef.current.validateBeforeSubmit();

    if (!imagesValid) {
      handleAlertwar("veuillez mettre au moins une image principal");
      return;
    }

    if (packageDimensions.weight === 0) {
      handleAlertwar(errorMessages.weightInvalid);
      return;
    }
    // if (packageDimensions.length === 0) {
    //   handleAlertwar(errorMessages.lengthInvalid);
    //   return;
    // }
    // if (packageDimensions.width === 0) {
    //   handleAlertwar(errorMessages.widthInvalid);
    //   return;
    // }
    // if (packageDimensions.height === 0) {
    //   handleAlertwar(errorMessages.heightInvalid);
    //   return;
    // }
    // if (shippingOptions.length === 0) {
    //   handleAlertwar(errorMessages.zoneInvalid);
    //   return;
    // }
    if (selectedOriginZone.length === 0 || selectedOriginZone === "choisir") {
      handleAlertwar(errorMessages.origineInvalid);
      return;
    }

    if (!ClefCategorie) {
      handleAlertwar(errorMessages.categorieInvalid);
      return;
    }

    // if (validateTransporteurs(shippingOptions)) {
    //   handleAlert("Prêt pour l'envoi au backend.");
    // } else {
    //   handleAlertwar("Erreur de validation.");
    //   return;
    // }

    // return;

    try {
      const formData = new FormData();

      formData.append("name", productData.name);
      formData.append("shippingZones", JSON.stringify(shippingOptions));
      formData.append("origine", selectedOriginZone);
      formData.append("weight", packageDimensions.weight);
      // formData.append("length", packageDimensions.length);
      // formData.append("width", packageDimensions.width);
      // formData.append("height", packageDimensions.height);
      formData.append("prix", productData.price);
      formData.append("ClefCategorie", ClefCategorie);
      formData.append("description", productData.desc);
      formData.append("sellerOrAdmin", "seller");
      formData.append("sellerOrAdmin_id", admin?.id);
      formData.append("quantite", productData.quantity);
      formData.append("prixPromo", productData.price_Promo);

      formData.append(
        "marque",
        productData.marque.length != 0 ? productData.marque : "inconu"
      );

      // Ajouter les images principales
      Object.entries(mainImages).forEach(([key, file]) => {
        if (file) formData.append(key, file);
      });

      // Ajouter les variantes

      // Ajouter les images des variantes
      variants.forEach((variant, index) => {
        if (variant.imageFile) {
          // Utiliser le nom de la couleur comme clé pour l'upload
          formData.append(`imageVariante${index}`, variant.imageFile);
        }
      });

      formData.append("variants", JSON.stringify(variants));
      setIsLoading(true);
      const response = await axios.post(
        `${BackendUrl}/api/productsRoutes/create`,
        formData
      );
      toast.success(response.data.message);

      // Réinitialiser le formulaire
      setProductData({
        desc: "",
        name: "",
        price: "",
        quantity: 0,
        price_Promo: 0,
        prixF: 0,
        Categorie: "",
        type_de_Produits: "",
        marque: "inconu",
        deliveryPrice: 0,
      });

      setPackageDimensions({
        weight: 0,
        length: 0,
        width: 0,
        height: 0,
      });
      setShippingOptions([]);
      setVariants([]);
      setMainImages({ image1: null, image2: null, image3: null });

      setPreview({ current: "", images: [] });
    } catch (error) {
      toast.error("Erreur lors de la création du produit");
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  // Fonction pour mettre à jour les images à supprimer (utilisée par le composant ProductImages) 1
  const updateImagesToDelete = (images) => {
    setImagesToDelete(images);
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-8 flex items-center justify-between">
          <h1 className="text-3xl font-bold text-gray-900">Nouveau Produit</h1>
          <button
            onClick={() => window.history.back()}
            className="flex items-center px-4 py-2 text-sm text-gray-600 hover:text-gray-900"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Retour
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-8">
          {/* Section des informations de base - Version modernisée */}
          <div className="bg-white shadow-lg rounded-xl p-6 md:p-8 border border-gray-100">
            <div className="flex items-center space-x-3 mb-6">
              <div className="bg-blue-100 p-2 rounded-lg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 text-blue-600"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10"
                  />
                </svg>
              </div>
              <h2 className="text-xl font-semibold text-gray-800">
                Informations de base
              </h2>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-5">
              <div className="space-y-1.5">
                <label className="block text-sm font-medium text-gray-700">
                  Nom du produit <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  value={productData.name}
                  onChange={(e) =>
                    setProductData((prev) => ({
                      ...prev,
                      name: e.target.value,
                    }))
                  }
                  className="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                  required
                  placeholder="Entrez le nom du produit"
                />
              </div>

              <div className="space-y-1.5">
                <label className="block text-sm font-medium text-gray-700">
                  Prix <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <span className="text-gray-500">€</span>
                  </div>
                  <input
                    type="number"
                    step="any"
                    value={productData.price}
                    onChange={(e) =>
                      setProductData((prev) => ({
                        ...prev,
                        price: e.target.value,
                      }))
                    }
                    className="w-full pl-8 pr-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                    required
                    min="0"
                    placeholder="0.00"
                  />
                </div>
              </div>

              <div className="space-y-1.5">
                <label className="block text-sm font-medium text-gray-700">
                  Prix promotionnel
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <span className="text-gray-500">€</span>
                  </div>
                  <input
                    type="number"
                    step="any"
                    value={productData.price_Promo}
                    onChange={(e) =>
                      setProductData((prev) => ({
                        ...prev,
                        price_Promo: Number(e.target.value),
                      }))
                    }
                    className="w-full pl-8 pr-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                    min="0"
                    placeholder="0.00"
                  />
                </div>
              </div>

              <div className="space-y-1.5">
                <label className="block text-sm font-medium text-gray-700">
                  Quantité <span className="text-red-500">*</span>
                </label>
                <input
                  type="number"
                  value={productData.quantity}
                  onChange={(e) =>
                    setProductData((prev) => ({
                      ...prev,
                      quantity: Number(e.target.value),
                    }))
                  }
                  className="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                  required
                  min="1"
                  placeholder="1"
                />
              </div>

              <div className="space-y-1.5">
                <label className="block text-sm font-medium text-gray-700">
                  Marque
                </label>
                <input
                  type="text"
                  defaultValue={productData.marque}
                  onChange={(e) =>
                    setProductData((prev) => ({
                      ...prev,
                      marque: e.target.value,
                    }))
                  }
                  className="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                  placeholder="Nom de la marque"
                />
              </div>

              <div className="space-y-1.5">
                <label className="block text-sm font-medium text-gray-700">
                  Type de Produits <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <select
                    className="w-full px-3 py-2.5 border border-gray-300 rounded-lg appearance-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all pr-10"
                    onChange={(e) => {
                      setClefCategorie(
                        categories[Number(e.target.selectedIndex) - 1]?._id
                      );
                    }}
                  >
                    <option>Choisir</option>
                    {categories ? (
                      categories?.map((param, index) => {
                        return <option key={index}>{param.name}</option>;
                      })
                    ) : (
                      <option>Aucun</option>
                    )}
                  </select>
                  <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                    <svg
                      className="h-5 w-5 text-gray-400"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Section des images */}
          <div className="space-y-4">
            <h3 className="text-lg font-medium text-gray-900">
              Images du produit
            </h3>
            <ProductImages
              ref={productImagesRef}
              mainImages={mainImages}
              setMainImages={setMainImages}
              currentImages={currentImages}
              setCurrentImages={setCurrentImages}
              updateImagesToDelete={updateImagesToDelete}
              setImagesToDelete={setImagesToDelete}
              imagesToDelete={imagesToDelete}
              formErrors={formErrors}
              setFormErrors={setFormErrors}
              showToast={showToast}
            />
          </div>

          <div className="bg-white shadow-lg rounded-xl p-6 md:p-8 border border-gray-100 mb-6">
            <div className="flex items-center space-x-3 mb-6">
              <div className="bg-indigo-100 p-2 rounded-lg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 text-indigo-600"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                  />
                </svg>
              </div>
              <h2 className="text-xl font-semibold text-gray-800">
                Description du produit
              </h2>
            </div>

            <div className="editor-container relative rounded-lg border border-gray-200 overflow-hidden">
              <div className="max-h-64 overflow-y-auto bg-white">
                <ReactQuill
                  value={productData.desc}
                  onChange={(value) =>
                    setProductData((prev) => ({ ...prev, desc: value }))
                  }
                  className="min-h-40 [&_.ql-toolbar]:border-t-0 [&_.ql-toolbar]:border-x-0 [&_.ql-toolbar]:border-b [&_.ql-toolbar]:border-gray-200 [&_.ql-toolbar]:bg-gray-50 [&_.ql-editor]:min-h-[150px] [&_.ql-editor]:p-4"
                  theme="snow"
                  modules={{
                    toolbar: [
                      [{ header: [1, 2, 3, false] }],
                      ["bold", "italic", "underline", "strike"],
                      [{ list: "ordered" }, { list: "bullet" }],
                      ["link", "video"],
                      ["clean"],
                    ],
                  }}
                  formats={[
                    "header",
                    "bold",
                    "italic",
                    "underline",
                    "strike",
                    "list",
                    "bullet",
                    "link",
                    "video",
                  ]}
                />
              </div>
              <div className="flex items-center py-2 px-4 bg-gray-50 border-t border-gray-200">
                <div className="text-xs text-gray-500 flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4 mr-1 text-gray-400"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M13 10V3L4 14h7v7l9-11h-7z"
                    />
                  </svg>
                  Faites défiler pour voir tout le contenu
                </div>
                <div className="ml-auto text-xs text-gray-500">
                  {productData.desc ? (
                    <span className="px-2 py-1 bg-blue-100 text-blue-700 rounded-full">
                      {productData.desc.replace(/<[^>]*>/g, "").length}{" "}
                      caractères
                    </span>
                  ) : (
                    <span>0 caractères</span>
                  )}
                </div>
              </div>
            </div>

            <div className="mt-4 text-sm text-gray-600">
              <p>
                Décrivez votre produit en détail pour aider vos clients à
                prendre leur décision d'achat.
              </p>
            </div>
          </div>

          {/* Section des variantes */}
          <div className="bg-white shadow rounded-lg p-6">
            <h2 className="text-xl font-semibold mb-6">Variantes du produit</h2>
            <ProductVariantForm
              variants={variants}
              setVariants={setVariants}
              defaultPrice={productData.price}
              defaultPromoPrice={productData.price_Promo}
              isEditMode={false}
            />
          </div>

          <ShippingRatesManager
            selectedOriginZone={selectedOriginZone}
            setSelectedOriginZone={setSelectedOriginZone}
            nouvelleZone={nouvelleZone}
            setNouvelleZone={setNouvelleZone}
            zones={zones}
            setZones={setZones}
            nouveauTransporteur={nouveauTransporteur}
            setNouveauTransporteur={setNouveauTransporteur}
            transporteurs={transporteurs}
            setTransporteurs={setTransporteurs}
            shippingOptions={shippingOptions}
            setShippingOptions={setShippingOptions}
            packageDimensions={packageDimensions}
            setPackageDimensions={setPackageDimensions}
          />

          {/* Boutons d'action */}
          <div className="flex justify-end space-x-4">
            <button
              type="button"
              onClick={() => window.history.back()}
              className="px-6 py-3 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Annuler
            </button>
            <button
              type="submit"
              disabled={isLoading}
              className="px-6 py-3 text-sm font-medium text-white bg-blue-600 rounded-md shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:bg-blue-400"
            >
              {isLoading ? "Création en cours..." : "Créer le produit"}
            </button>
          </div>
        </form>
      </div>
      <ToastContainer />
    </div>
  );
}
